// extracted by mini-css-extract-plugin
export default {"container":"style_container__b0FbJ","text":"style_text__+GJ3n","arrow":"style_arrow__vf0-r"};